// LLM generated - Model Claude 4 Sonnet
import { useQuery } from '@tanstack/react-query';
import { getAvailableReactions } from '../live-activity-service.service.api';
import type { GetReactionsResponse } from '../types';
import { createQueryKey } from '~/domains/contest/domains/gamecenter/domains/common/components/ContestChat/constants/queryKeys';
import { STALE_TIME } from '~/domains/contest/constants/query';

export function useAvailableReactions() {
  return useQuery<GetReactionsResponse>({
    queryKey: createQueryKey.availableReactions(),
    queryFn: getAvailableReactions,
    staleTime: STALE_TIME,
    cacheTime: 10 * 60 * 1000, // 10 minutes
  });
}
